import React from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const Header = ({
    isEdit,
    destinationSelections,
}) => {
    const language = useSelector(
        (state: any) => state.languagesState.languages,
    );

    return isEdit ? (
        <Modal.Header>
            <Modal.Title>
                {" "}
                {language?.lead?.edit ?? "Edit"} {destinationSelections}
            </Modal.Title>
        </Modal.Header>
    ) : (
        <Modal.Header>
            <Modal.Title>
                {" "}
                {language?.lead?.create_new ?? "Create New"}{" "}
                {destinationSelections}
            </Modal.Title>
        </Modal.Header>
    );
};

export default Header;
